var _path, _path2, _rect, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4472 5.10557C19.786 4.428 20.4785 4 21.2361 4H42.7639C43.5215 4 44.214 4.428 44.5528 5.10557L46 9H18L19.4472 5.10557Z",
    fill: "url(#paint0_linear_679_88)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8H54L50.7267 54.422C50.5051 57.5642 47.8914 60 44.7415 60H19.2585C16.1086 60 13.4949 57.5642 13.2733 54.422L10 8Z",
    fill: "url(#paint1_linear_679_88)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 56,
    height: 8,
    rx: 2,
    fill: "url(#paint2_linear_679_88)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31.2559V30.0709C26.6077 30.5561 24 33.4735 24 37C24 38.582 24.5248 40.0415 25.4098 41.2137C26.0021 41.9983 26.2306 43.0647 25.7391 43.916L25.6824 44.0143C25.0903 45.0398 23.726 45.3358 22.922 44.4664C21.1083 42.5051 20 39.882 20 37C20 31.262 24.3935 26.5501 30 26.0448V24.744C30 24.1961 30.4297 23.8366 30.7998 24.0749L35.685 27.2199C36.0987 27.4862 36.1067 28.2678 35.6986 28.549L30.8134 31.916C30.4424 32.1717 30 31.8127 30 31.2559Z",
    fill: "url(#paint3_linear_679_88)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42.7441V43.8595C37.3923 43.3742 40 40.4568 40 36.9304C40 35.3483 39.4752 33.8889 38.5902 32.7166C37.9979 31.9321 37.7694 30.8656 38.2609 30.0143L38.3176 29.9161C38.9097 28.8906 40.274 28.5946 41.078 29.464C42.8917 31.4253 44 34.0484 44 36.9304C44 42.6684 39.6065 47.3803 34 47.8855V49.256C34 49.8039 33.5703 50.1634 33.2002 49.9251L28.315 46.7801C27.9013 46.5138 27.8933 45.7322 28.3014 45.451L33.1866 42.084C33.5576 41.8283 34 42.1873 34 42.7441Z",
    fill: "url(#paint4_linear_679_88)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 8.89543 4.89543 8 6 8H58C59.1046 8 60 8.89543 60 10V14C60 15.1046 59.1046 16 58 16H6C4.89543 16 4 15.1046 4 14V10Z",
    fill: "url(#paint5_linear_679_88)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_679_88",
    x1: 32,
    y1: 4,
    x2: 32,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7C6CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_679_88",
    x1: 10,
    y1: 8,
    x2: 61.2828,
    y2: 51.3931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.236021,
    stopColor: "#EFF2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677268,
    stopColor: "#B7C6CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_679_88",
    x1: 4,
    y1: 8,
    x2: 6.24,
    y2: 23.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70351,
    stopColor: "#B7C6CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_679_88",
    x1: 44,
    y1: 50,
    x2: 18.0831,
    y2: 26.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0930505,
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562656,
    stopColor: "#0085FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_679_88",
    x1: 44,
    y1: 50,
    x2: 18.0831,
    y2: 26.0767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0930505,
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562656,
    stopColor: "#0085FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_679_88",
    x1: 4,
    y1: 8,
    x2: 6.24,
    y2: 23.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.192427,
    stopColor: "#EFF2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771542,
    stopColor: "#B7C6CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.9f3ae177e48c2bc1ed514ace24c48e8b.svg";
export { ForwardRef as ReactComponent };